import script from "./MyPager.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPager.vue?vue&type=script&setup=true&lang=js"

import "./MyPager.vue?vue&type=style&index=0&id=b658c324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b658c324"]])

export default __exports__